import REBSCarousel from './components/rebs-carousel';


function initializeCarousels() {
  $('.rebs-carousel').each(function(index, el) {
    new REBSCarousel(el, {
      enableFullscreen: false
    });
  });
}


$(function () {
  initializeCarousels();
});
